module.exports = __webpack_public_path__ + "img/how_to_play_gray.4b458ccb.png";